import { faPlay as fasPlay } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { AbstractStepProps } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import bankmonitorImage from "@/img/logos/bankmonitor-white.svg";
import { Alert, ButtonLegacy, FormCheckList, FormRadio, List } from "@/shared/ui";
import type { AdditionalInsuranceGoal, MainInsuranceGoal } from "./Step1.data";
import { ADDITIONAL_INSURANCE_GOAL, MAIN_INSURANCE_GOAL } from "./Step1.data";

export interface StepFields {
	mainInsuranceGoal: MainInsuranceGoal;
	additionalInsuranceGoal: AdditionalInsuranceGoal[];
}

export interface Props extends AbstractStepProps {
	showDetectiveAlert?: boolean;
}

export class Step1 extends AbstractStep<StepFields, Props> {
	protected initValues(): StepFields {
		return {
			mainInsuranceGoal: "RISK_INSURANCE",
			additionalInsuranceGoal: [],
		};
	}

	protected renderContent(): ReactNode {
		const { showDetectiveAlert } = this.props;

		return (
			<>
				<Card.Header className="bg-secondary-gradient text-center text-white">
					<img
						className="my-1"
						src={bankmonitorImage}
						width="160"
						height="25"
						alt="Bankmonitor"
						loading="eager"
					/>
					<hr />
					<div className="h2 mb-0 text-uppercase">
						Kiszámoljuk <strong className="text-nowrap font-weight-black">mennyibe kerül</strong>
						<br />a családod védelme
					</div>
					<hr />
				</Card.Header>
				<Card.Body className="d-flex flex-column">
					<div className="h4 text-uppercase text-center mt-2">
						Milyen kockázatokra
						<br />
						szeretnél megoldást?
					</div>
					<FormRadio
						label="Alapvető biztosítások"
						name="mainInsuranceGoal"
						options={MAIN_INSURANCE_GOAL}
						required
					/>
					<FormCheckList
						label="Kiegészítő elemek"
						name="additionalInsuranceGoal"
						options={ADDITIONAL_INSURANCE_GOAL}
					/>
					{showDetectiveAlert && (
						<Alert variant="info">
							<List itemStyle="gift" variant="primary" className="pl-4 mb-1">
								<List.Item>
									<strong>
										Vegyél részt a{" "}
										<a
											href="/mediatar/cikk/indul-a-bankmonitor-biztositasi-detektiv/?link_type=info-box"
											// biome-ignore lint/a11y/noBlankTarget: in-page link
											target="_blank"
										>
											Bankmonitor Biztosítási Detektív
										</a>{" "}
										akcióban!
									</strong>
								</List.Item>
							</List>
						</Alert>
					)}
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy type="submit" icon={<FontAwesomeIcon icon={fasPlay} />} className="text-uppercase">
						Kalkuláció indítása
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Step1";
	}
}
